module.exports = __webpack_public_path__ + "img/logo.855d90fc.png";